import { CheckCircle, Coins02, PackageCheck, Send01 } from "@untitledui/icons";
import { useState } from "react";
import { useSampleRequestTabCounts } from "@/api/sample-requests";
import { useSampleRulesCount } from "@/api/sample-rules";
import { PageHero, PageHeroKey } from "@/components/application/page-hero/page-hero";
import { Button } from "@/components/base/buttons/button";
import { LoadingPageState } from "@/components/loading-page-state";
import { PageLayout } from "@/components/page-layout";
import { SampleRulesDrawer } from "@/components/sample-requests/sample-rules-drawer";
import { SampleRulesButton } from "./sample-requests-controls";
import { SampleRequestsFirstRun } from "./sample-requests-first-run";
import { SampleRequestsTable } from "./sample-requests-table";
import { SetAllocationsModal } from "./set-allocations-modal";

const SUBTITLE =
  "All open sample requests across active collaborations. Pick a saved view to apply a filter set, or open Filters to refine.";

export function SampleRequestsManagement() {
  const { data: counts, isLoading: isLoadingCounts } = useSampleRequestTabCounts();
  const [allocationsOpen, setAllocationsOpen] = useState(false);
  const [rulesOpen, setRulesOpen] = useState(false);
  const { data: rulesCountData } = useSampleRulesCount();
  const hasAnyRequests = counts ? Object.values(counts).some((count) => (count ?? 0) > 0) : undefined;

  if (isLoadingCounts) return <LoadingPageState />;

  if (hasAnyRequests === false) {
    return <SampleRequestsFirstRun />;
  }

  return (
    <PageLayout
      title="Sample Requests Management"
      icon={Send01}
      subtitle={SUBTITLE}
      callToAction={
        <div className="flex items-center gap-3">
          <SampleRulesButton rulesCount={rulesCountData?.total ?? 0} onRulesClick={() => setRulesOpen(true)} />
          <Button color="primary" size="sm" onClick={() => setAllocationsOpen(true)}>
            Set Allocations
          </Button>
        </div>
      }
    >
      <PageHero
        pageKey={PageHeroKey.SampleRequests}
        title="Manage sample requests and see what it made"
        text1={{ icon: CheckCircle, message: "Approve, Reject or Ignore Requests." }}
        text2={{ icon: PackageCheck, message: "Keep Track of how many Requests you have pending." }}
        text3={{ icon: Coins02, message: "Allocate monthly amount per month of samples to approve" }}
        image="/heroes/sample-requests.png"
        imageLayout="composition"
      />
      <SampleRequestsTable />

      <SetAllocationsModal open={allocationsOpen} onOpenChange={setAllocationsOpen} />
      <SampleRulesDrawer open={rulesOpen} onOpenChange={setRulesOpen} />
    </PageLayout>
  );
}
